import { PERMISSIONS } from '../shared/constants/permissions';
import type { Tender } from '../types/tender';

export const filterVisibleTenders = (
  tenders: Tender[],
  account: { cachedPermissions?: string[]; role?: string; teamId?: string; uid?: string } | null,
  usersMap: Record<string, { displayName: string; teamId?: string }>
): Tender[] => {
  if (!account) {
    return [];
  }

  return tenders.filter((tender) => {
    // If user is a team lead (has MANAGE_TEAM but not VIEW_ALL), they see their own tenders AND tenders owned by their team members
    const hasTeamManage = account.cachedPermissions?.includes(PERMISSIONS.TENDER_MANAGE_TEAM);
    const hasViewAll = account.cachedPermissions?.includes(PERMISSIONS.TENDER_VIEW_CLIENT);

    if (hasTeamManage && !hasViewAll && account.teamId) {
      const owner = usersMap[tender.ownerId || ''];
      // Check if owner is in the map and matches team, OR if the viewer is the owner, OR if it's shared with them
      const isTeamMemberTender = owner && owner.teamId === account.teamId;
      const isOwnTender = tender.ownerId === account.uid;
      const isSharedTender =
        tender.sharedWith && account.uid ? tender.sharedWith.includes(account.uid) : false;

      return isOwnTender || isTeamMemberTender || isSharedTender;
    }

    // For admins (VIEW_ALL), they see everything fetched
    return true;
  });
};
